import { Injectable } from '@angular/core';
import { PermissionType } from '../permission-type.enum';
import { PermissionsFactory } from '../permissions-factory';
import { AuthService } from 'src/app/core/services/auth.service';
import { Permission } from '../models/permission.model';

@Injectable()
export class PermissionManagerService {
  private permissions: Permission[];
  user: any;

  constructor(private authService: AuthService) {
    this.user = this.authService.currentUserValue;
    this.permissions = this.user.permissions; // PermissionsFactory.getInstance();
  }

  isGranted(resource: string, item: string, permission: PermissionType) {
    if (this.permissions) {
      for (const res of this.permissions) {
        if (resource == res.screen) {
          for (const it of res.items) {
            if (item == it.item)
              for (const perm of Object.keys(it.permissions)) {
                if ( perm == permission) {
                  return Object(it.permissions)[perm];
                }
              }
          }
        }
      }
    }
    return false;
  }
}
